import { render, staticRenderFns } from "./TreatmentSectionFreeForm.vue?vue&type=template&id=a4b56494&scoped=true"
import script from "./TreatmentSectionFreeForm.vue?vue&type=script&lang=js"
export * from "./TreatmentSectionFreeForm.vue?vue&type=script&lang=js"
import style0 from "./TreatmentSectionFreeForm.vue?vue&type=style&index=0&id=a4b56494&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b56494",
  null
  
)

export default component.exports